/**
 * Body editor for the define step: symbol name = value, on one row.
 */
import React from "react"
import { QueryBuilderStore } from "stores/queryBuilderStore"
import { DefineStep } from "types/queryBuilder.types"
import { StepBodyProps } from "./stepBodyProps"

export interface DefineStepBodyProps extends StepBodyProps<DefineStep> {
  renameStep: QueryBuilderStore["renameTransformStep"]
  setDefineValue: QueryBuilderStore["setDefineValue"]
}

const DefineStepBody: React.FC<DefineStepBodyProps> = ({
  step,
  renameStep,
  setDefineValue,
}) => (
  <div className="qc-step__field-row">
    <input
      className="qc-recodes__name qc-mono"
      type="text"
      value={step.symbol}
      onChange={(e) => renameStep(step.id, e.target.value)}
      placeholder="MY_VALUE"
      aria-label="Symbol name"
      style={{ maxWidth: 180 }}
    />
    <span className="qc-loop__keyword">=</span>
    <input
      className="qc-recodes__name qc-mono"
      type="text"
      value={step.value}
      onChange={(e) => setDefineValue(step.id, e.target.value)}
      placeholder="Anything — typed as-is into following steps"
      aria-label="Value"
      style={{ flex: 1 }}
    />
  </div>
)

export default DefineStepBody
